import { useMemo, useCallback } from "react";
// import { MapProvider } from "react-map-gl";

// eslint-disable-next-line no-unused-vars
import { Header, Map, SearchBar, Spinner } from "./components";

import {
  // useAws,
  // useGeolocation,
  // useLoadGoogleAnalitycs,
  // useLoadGoogleTagManager,
  // useLoadFacebookPixel,
  useQueryParams
} from "./hooks";
// import { AWS_IDENTITY, AWS_REGION } from "./utils/env";

// const initialCoords = {
//   longitude: -58.4411745,
//   latitude: -34.6420621,
// };

const App = () => {
  // eslint-disable-next-line no-unused-vars
  // const [client, transformRequest] = useAws(AWS_IDENTITY, AWS_REGION);
  // eslint-disable-next-line no-unused-vars
  // const currentLocationUser = useGeolocation(initialCoords);
  // // useLoadGoogleAnalitycs('G-KSXL568Z5Q');
  // useLoadGoogleTagManager('GTM-MSFBW8HX');
  // useLoadFacebookPixel('667045987921454');

  const {
    only_map: onlyMapQueryParams,
    hidden_extra_components: hiddenExtraComponentsQueryParams,
  } = useQueryParams();

  const showOnlyMap = useMemo(
    () => onlyMapQueryParams ? JSON.parse(onlyMapQueryParams) : false,
    [onlyMapQueryParams],
  );

  const hiddenExtraComponentsArray = useMemo(
    () => hiddenExtraComponentsQueryParams ? hiddenExtraComponentsQueryParams.split(',') : [],
    [hiddenExtraComponentsQueryParams],
  );

  const isHiddenComponent = useCallback(
    (componentName) => {
      if (hiddenExtraComponentsArray.length > 0) {
        return hiddenExtraComponentsArray.includes(componentName)
      }

      return showOnlyMap
    },
    [hiddenExtraComponentsArray, showOnlyMap],
  );

  const showHeader = useMemo(
    () => !isHiddenComponent('header'),
    [isHiddenComponent],
  );

  // const showSearchBar = useMemo(
  //   () => !isHiddenComponent('searchbar'),
  //   [isHiddenComponent],
  // );

  return (
    <div>
      {showHeader && <Header />}

      <iframe
        title="Propuesta"
        src="https://mapa.kripton.la"
        allow="geolocation; clipboard-write; web-share; fullscreen"
        allowfullscreen
        referrerpolicy="no-referrer"
        loading="lazy"
        className={showHeader ? "container-root-with-header" : "container-root"}
      />

      {/* <div className={showHeader ? "container-root-with-header" : "container-root"}>
        {transformRequest ? (
          <MapProvider>
            <Map
              transformRequest={transformRequest}
              currentLocationUser={currentLocationUser}
            />

            {showSearchBar && <SearchBar client={client} />}
          </MapProvider>
        ) : (
          <Spinner />
        )}
      </div> */}
    </div>
  );
};

export default App;
